/* global axios */
import ApiClient from './ApiClient';

class CustomSlaReportsAPI extends ApiClient {
  constructor() {
    super('custom_sla_reports', { accountScoped: true });
  }

  getMetrics({
    from,
    to,
    inboxId,
    teamId,
    assignedAgentId,
    customSlaPolicyId,
  } = {}) {
    return axios.get(`${this.url}/metrics`, {
      params: {
        since: from,
        until: to,
        inbox_id: inboxId,
        team_id: teamId,
        assigned_agent_id: assignedAgentId,
        custom_sla_policy_id: customSlaPolicyId,
      },
    });
  }

  download({
    from,
    to,
    inboxId,
    teamId,
    assignedAgentId,
    customSlaPolicyId,
  } = {}) {
    return axios.get(`${this.url}/download`, {
      params: {
        since: from,
        until: to,
        inbox_id: inboxId,
        team_id: teamId,
        assigned_agent_id: assignedAgentId,
        custom_sla_policy_id: customSlaPolicyId,
      },
    });
  }

  getConversations({
    from,
    to,
    inboxId,
    teamId,
    assignedAgentId,
    customSlaPolicyId,
    page = 1,
  } = {}) {
    return axios.get(`${this.url}/conversations`, {
      params: {
        since: from,
        until: to,
        inbox_id: inboxId,
        team_id: teamId,
        assigned_agent_id: assignedAgentId,
        custom_sla_policy_id: customSlaPolicyId,
        page,
      },
    });
  }
}

export default new CustomSlaReportsAPI();
